'use strict';

require('array.prototype.flat/auto');
require('array.prototype.flatmap/auto');

require('symbol.prototype.description/auto');

require('object.fromentries/auto');

require('./es2020');
